import React from 'react';
import system from 'helpers/system';
import {StyleSheetManager} from 'styled-components';
import createCache from '@emotion/cache';
import {CacheProvider} from '@emotion/react';
import {captureHydration, styleSheet, watchHydration} from 'helpers/hydrate';
import {recordedProps, clearRecordedProps} from 'helpers/styles';

const emotionCache = createCache({key: 'css', speedy: false});

if (system.isDevelopment()) {
  // copy(JSON.stringify(__hydrate.capture(), null, 2)) -> src/theme/hydration.json
  // const watch = __hydrate.watch(); ... ; watch.report() -> what the payload still misses
  //
  // props() is the recorded pre-attrs input per styled component (npm start only, empty in a
  // serve:develop build). copy(JSON.stringify(__hydrate.props())) after a walk to save it, and
  // clearProps() to start over.
  window.__hydrate = {
    capture: captureHydration,
    watch: watchHydration,
    props: recordedProps,
    clearProps: clearRecordedProps
  };
}

const StyleProvider = (props) => {
  return <CacheProvider value={emotionCache}>
    <StyleSheetManager sheet={styleSheet}>
      {props.children}
    </StyleSheetManager>
  </CacheProvider>
};

StyleProvider.propTypes = {
};

export default StyleProvider;
